import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
    name: 'box',
    initialState: {
        goodId: null,
        // goodOptions: [],
    },
    reducers: {
        setBoxGoodId(state, action) {
            state.goodId = action.payload
        },
        // setBoxGoodOptions(state, action) {
        //     state.goodOptions = action.payload
        // },
    }
})

export default slice.reducer

export const {
    setBoxGoodId,
    // setBoxGoodOptions,
} = slice.actions